import React from "react";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { FiBarChart2 } from "react-icons/fi";
import { GiRobotGolem } from "react-icons/gi";
import { BsFileEarmarkText } from "react-icons/bs";
import { motion } from "framer-motion";

import rebalance_logo from "../../../assets/rebalance_logo.png"; // Replace with your image path

const features = [
  {
    icon: <FaMoneyCheckAlt className="text-pink-600 text-3xl mb-4" />,
    title: "Performance Based Payments",
    description: "Pay per actual engagement (CPC, CPV)",
  },
  {
    icon: <FiBarChart2 className="text-pink-600 text-3xl mb-4" />,
    title: "Real time Analytics",
    description: "Pay per actual engagement (CPC, CPV)",
  },
  {
    icon: <GiRobotGolem className="text-pink-600 text-3xl mb-4" />,
    title: "AI Driven matching",
    description: "Smart brand creator connection",
  },
  {
    icon: <BsFileEarmarkText className="text-pink-600 text-3xl mb-4" />,
    title: "Automated Reporting",
    description: "Transparent Data driven decisions",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: "spring", stiffness: 120, damping: 16 },
  },
  hover: {
    scale: 1.05,
    boxShadow: "0 8px 32px rgba(236, 72, 153, 0.15)",
    transition: { type: "spring", stiffness: 300, damping: 18 },
  },
};

const FeaturesOverview = () => {
  return (
    <div
      className="py-10 px-8 mx-8 xs:mx-4 xs:px-4 md:px-16 lg:px-20"
      style={{ fontFamily: "Gilroy-Medium" }}
    >
      <motion.h2
        className="text-2xl md:text-3xl font-bold text-center mb-10 text-black"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Features Overview
      </motion.h2>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="flex items-center justify-center flex-col bg-white rounded-[24px] border-2 border-gray-300 shadow-md p-6 text-center hover:shadow-xl transition-transform duration-300"
            variants={cardVariants}
            whileHover="hover"
          >
            <div>{feature.icon}</div>
            <div>
              <h3 className="font-semibold text-lg mb-2">{feature.title}</h3>
            </div>
            <div>
              <p
                className="text-sm text-gray-600"
                style={{ fontFamily: "Gilroy-Medium" }}
              >
                {feature.description}
              </p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default FeaturesOverview;
